// import { createContext } from "react";
// const ProfileContext = createContext();
// export default ProfileContext;

// contexts/ProfileContext.js
import { createContext, useState, useEffect } from "react";

const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const [profile, setProfile] = useState({
    name: "Admin User",
    email: "admin@company.com",
    photo: "", // "/no_image.jpg" ইত্যাদি
  });

  // এই useEffect এর মাধ্যমে localStorage থেকে প্রোফাইল লোড হবে
  useEffect(() => {
    const storedProfile = localStorage.getItem("profile");
    if (storedProfile) {
      setProfile(JSON.parse(storedProfile));
    }
  }, []);

  return (
    <ProfileContext.Provider value={{ profile, setProfile }}>
      {children}
    </ProfileContext.Provider>
  );
};

export default ProfileContext;
